import React from 'react'

import { Icon as UIIcon, type IconProps } from '../Icon/Icon'
import styles from './styles.module.css'

export function Icon({ ...props }: IconProps) {
  return (
    <UIIcon
      {...props}
      className={styles.icon}
      withCircleBackground
      size='md'
      style={{ flexShrink: 0 }}
    />
  )
}
